<template>
  <div>
    <page-header has-return :page="pageHeaderConfig" />
    <filter-manager
          ref="filterRef"
          :filters="filtersConfig"
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync pr-2"
          search-text=""
          search-container-class="btn-process-custom d-flex align-items-center justify-content-end"
          v-model="filterModel"
          @search="onProcessHandler"
        >
      <div class="col d-flex justify-content-end align-items-center">
        <dropdown
          v-if="canQueue"
          icon="fas fa-print"
          :items="reportOptions"
          title="Seleccione"
        />
      </div>
    </filter-manager>
    <queue-report-status
          :queue-report="queueInfo"
          @on-cancel="cancelQueue"
          @on-download="downloadQueueReport"/>
  </div>
</template>

<script>
//libs components
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import Dropdown from 'dropdown'

//services
import AcademicYearServices from '@/services/api/academicyear.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'

//constants
import codeAcademicYear from '@/utils/constants/codeAcademicYear.js'
import queueReportTypes from "@/utils/constants/queueReportTypes";
import queueReportStatus from "@/utils/constants/queueReportStatus";
import QueueReportStatus from "@/views/progress/shared/components/QueueReportStatus.vue";
import Vue from "vue";
import hubservice from "@/services/api/hub/hubservice";

export default {
  name: 'RequestAndContracts',
  components: {
    QueueReportStatus,
    PageHeader,
    FilterManager,
    Dropdown,
  },
  mixins: [alertMixin],
  data: () => ({
    queueInfo: null,
    filterOptions: {
      academicYears: [],
    },
    filterModel: {
      academicYear: null,
    },
  }),
  computed: {
    canQueue() {
      return this.queueInfo === null
        || this.queueInfo.statusId === queueReportStatus.Completed
        || this.queueInfo.statusId === queueReportStatus.Failed
    },
    pageHeaderConfig() {
      return {
        icon: 'fas fa-chart-pie',
        title: 'Informe Solicitudes y Contratos',
        routes: ['Inicio', 'Reportes', 'Informe Solicitudes y Contratos'],
      }
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-4',
          options: this.filterOptions.academicYears,
        },
      ]
    },
    reportOptions() {
      return [
        {
          label: 'Excel',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(false),
        },
        {
          label: 'PDF',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(true),
        },
      ]
    },
  },
  async mounted() {
    await this.getInitialFilters()
    const res = await ReportServices.getPreviousGeneratedReport([queueReportTypes.RequestsContractsReportExcel, queueReportTypes.RequestsContractsReportPDF])
    this.queueInfo = res.data !== '' ? res.data : null;
  },
  created() {
    Vue.use(hubservice)
    this.$userHub.$on('hub-receive-status-queue-report', this.updateReceivedQueueStatusByHub)
  },
  beforeDestroy() {
    //clean SignalR event
    this.$userHub.$off('hub-receive-status-queue-report', this.updateReceivedQueueStatusByHub)
  },
  methods: {
    async downloadQueueReport(executionLogId) {
      ReportServices.downloadQueueReport(executionLogId)
        .then((res) => DocumentServices.Download(res.data))
        .catch((err) => {
          this.ShowToast("", err.response?.data?.message, "error");
        });
    },
    async cancelQueue(executionLogId) {
      ReportServices.cancelQueueReport(executionLogId)
        .then((res) => {
          if (res.data) {
            this.ShowToast(
              'Proceso Exitoso',
              'La ejecución del reporte ha sido cancelada exitosamente.',
              'success'
            );
            this.queueInfo = null;
          }
        })
        .catch((err) => {
          this.ShowToast("", err.response?.data?.message, "error");
        });
    },
    updateReceivedQueueStatusByHub(res) {
      this.queueInfo = res.respose;
    },

    async getInitialFilters() {
      this.filterOptions.academicYears = (
        await AcademicYearServices.getAcademicYearsFromSpecificYear(
          codeAcademicYear['2016-2017']
        )
      ).data
    },
    async onProcessHandler(isPdfFormat) {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }
      ReportServices.queueReport('rprequestcontract', {
        academicYearId: this.filterModel.academicYear.id,
        isPdfFormat,
      }).then(res => {
        this.queueInfo = {
          executionLogId: res.data,
          statusId: queueReportStatus.Pending,
          expired: false
        }
      });
    },
  },
}
</script>
